export default {
    controller: 'quickBookController',
    template: require('../views/quickBook.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/quickBook.component.js